/**
 * @deprecated This Enum Type is deprecated from v0.6.0
 */
export enum WorkspaceErrorTypes {
  Warning,
  Error
}

export enum WorkspaceErrorTypesV2 {
  SIMILAR_TAB_ERROR,
  MAX_TAB_COUNT_EXCEEDED_ERROR,
  CONSOLE_ERROR
}
